/*
 * (c) Copyright Reserved EVRYTHNG Limited 2021. All rights reserved.
 * Use of this material is subject to license.
 * Copying and unauthorised use of this material strictly prohibited.
 */

import * as onetrust from './oneTrust.js';

/**
 * @callback consentChangedCallback
 * @param {boolean} areCookiesAllowed
 */

/**
 * @typedef CookieManager
 * @property {function(): boolean} getAreCookiesAllowed
 * @property {function(): boolean} getIsCookieBannerClosed
 * @property {function(): boolean} getIsLoaded
 * @property {function(consentChangedCallback): void} setConsentChangedHandler
 */

/**
 * @param {string} type
 * @returns {CookieManager}
 */
export default function resolveCookieManager(type) {
  switch (type) {
    case 'onetrust':
      return onetrust;
    default:
      return onetrust;
  }
}
